module.exports = __webpack_public_path__ + "img/POP-00012-1.99d7cad6.png";